export default {
  tr: {
    name: 'Turkey',
    rtl: false,
    file: () => require('./lang/tr.json'),
  },
  'ar-sa': {
    name: 'Saudi Arabia',
    rtl: true,
    file: () => require('./lang/arb.json'),
  },
  'en-us': {
    name: 'USA',
    rtl: false,
    file: () => require('./lang/us.json'),
  },
};
